export interface AuthCompletion { isNew: boolean; completionId: string; }
/** First-party verification only. Proofs and tokens are never analytics parameters. */
export async function confirmAuthCompletion(authBaseUrl: string, receipt: unknown, accessToken: string): Promise<AuthCompletion | null> {
  if (typeof receipt !== 'string' || receipt.length > 4096 || !receipt) return null;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 3000);
  try {
    const response = await fetch(`${authBaseUrl}/auth/completion`, { method: 'POST', credentials: 'omit', signal: controller.signal,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }, body: JSON.stringify({ receipt }) });
    if (!response.ok) return null;
    const body = await response.json() as { success?: boolean; data?: Partial<AuthCompletion> };
    if (!body.success || typeof body.data?.isNew !== 'boolean' || typeof body.data.completionId !== 'string') return null;
    return { isNew: body.data.isNew, completionId: body.data.completionId };
  } catch { return null; } finally { clearTimeout(timer); }
}
